

export const featured = [
    {
      cover: "../imgs/pType/t1.png",
      name: "Family House",
      total: "122",
    },
    {
      cover: "../imgs/pType/t2.png",
      name: "House & Villa",
      total: "155",
    },
    {
      cover: "../imgs/pType/t3.png",
      name: "Apartment",
      total: "300",
    },
    {
      cover: "../imgs/pType/t4.png",
      name: "Office & Studio",
      total: "80",
    },
    {
      cover: "../imgs/pType/t5.png",
      name: "Villa & Condo",
      total: "80",
    },
  ]

  export const popular = [
      {
        cover: "../imgs/popular/1.jpg",
        name: "BPTP",
        bed: "3",
        bath:"2",
        add:"45, Sector-15, Delhi",
      },
      {
        cover: "../imgs/popular/2.jpg",
        name: "Puri",
        bed: "5",
        bath:"3",
        add:"15, Sector-64, Goa",
      },
      {
        cover: "../imgs/popular/3.jpg",
        name: "Sushma",
        bed: "4",
        bath:"3",
        add:"64, Sector-36, Mumbai",
      },
    ]